module.exports = "/10/0-file-va-cac-thao-tac-co-ban-voi-file-trong-c/index.html.e3b3167fa54cf742d8cdf50a549a00ab.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/35276.md
 ** module id = 585
 ** module chunks = 0
 **/